class ValtTagManager {
  constructor() {
    this.viewedComponents = []
    this.viewTrackElement = []
    this.pageloadTimestamp = Date.now()
    this.observerConfig = {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    }
    this.targetNode = document.body
    this.observedElements = []
  }

  observeChanges() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        this.mutationHandler(mutation)
      })
    })
    observer.observe(this.targetNode, this.observerConfig)
  }

  mutationHandler({ target, addedNodes }) {
    const dataAttr = target.dataset && target.dataset.nt
    if (dataAttr) {
      const elements = ValtTagManager.createElementArray(target)

      if (!addedNodes) {
        return
      }
      this.checkAndAddNodes(elements)
    }
  }

  checkAndAddNodes(elementArray) {
    const newElements = elementArray.filter(
      el => !this.observedElements.includes(el)
    )

    if (!newElements.length) {
      return
    }
    this.observedElements = this.observedElements.concat(...newElements)
    this.init(newElements)
  }

  static createElementArray(target) {
    return [target, ...Array.from(target.querySelectorAll('[data-nt]'))]
  }

  init(newNtElements) {
    if (newNtElements) {
      this.components = Array.from(newNtElements).filter(nt =>
        nt.dataset.nt.includes('component')
      )
      this.elements = Array.from(newNtElements).filter(
        nt => nt.dataset.nt.includes('component') === false
      )
    } else {
      this.ntElements = Array.from(
        document.querySelectorAll('[data-nt]')
      ).filter(el => !el.dataset.nt.includes('component'))
      this.allNtComponents = Array.from(
        document.querySelectorAll('[data-nt^="component"]')
      )

      this.elements = this.ntElements
      this.components = this.allNtComponents
    }

    this.elements.forEach(nt => {
      // Add events.
      if (
        (nt.nodeName === 'INPUT' ||
          nt.nodeName === 'SELECT' ||
          nt.nodeName === 'TEXTAREA') &&
        (nt.getAttribute('type') !== 'submit' &&
          nt.getAttribute('type') !== 'button' &&
          nt.getAttribute('type') !== 'checkbox' &&
          nt.getAttribute('type') !== 'radio')
      ) {
        nt.addEventListener(
          'blur',
          event => {
            this.sendEventInfo(nt, event)
          },
          false
        )
      } else if (
        nt.nodeName === 'A' ||
        nt.nodeName === 'SPAN' ||
        nt.nodeName === 'BUTTON' ||
        nt.nodeName === 'DIV' ||
        (nt.nodeName === 'INPUT' || nt.getAttribute('type') === 'submit')
      ) {
        nt.addEventListener(
          'click',
          event => {
            this.sendEventInfo(nt, event)
          },
          false
        )
      }
    })

    this.setTrackingAttributes()

    this.components.forEach((nt, index) => {
      this.isComponentInPage(nt, index)
    })

    // Check on scroll if component is in page viewport
    window.addEventListener(
      'scroll',
      ValtTagManager.throttle(() => {
        this.components.forEach((nt, index) => {
          this.isComponentInPage(nt, index)
        })
      }, 300)
    )
  }

  sendEventInfo(nt, event, index) {
    // Example: data-nt="method.ID.Value"
    this.eventInfo = {
      className: nt.getAttribute('class') || null,
      nodeName: nt.nodeName || null,
      elementType: nt.getAttribute('type') || null,
      elementSource: nt.getAttribute('src') || null,
      elementUrl: nt.href || window.location.href,
      elementIsChecked: nt.checked || null,
      // elementValue: nt.value || nt.innerText || null,
      eventMethod:
        nt
          .getAttribute('data-nt')
          .split('.')
          .shift() || null,
      eventID: nt.getAttribute('data-nt').split('.')[1] || null,
      elementValue:
        nt
          .getAttribute('data-nt')
          .split('.')[2] || null,
      // eventName: event.type ? event.type : event || null,
      // eventLabel: nt.getAttribute('data-nt') || null,
      // eventID: nt.getAttribute('data-nt').split('.')[1] || null,
      // eventAction:
      //   nt
      //     .getAttribute('data-nt')
      //     .split('.')
      //     .pop() || null,
      pagePath: window.location.pathname || null,
      timestampMS: Date.now() - this.pageloadTimestamp,
      pageComponentsTotal:
        document.querySelectorAll('[data-nt^="component"]').length + 1,
      pageComponentIndex: index + 1 || 0
    }

    if (!window.ga) return

    try {
      // window.ga(this.eventInfo.eventMethod, {
      //   hitType: 'event',
      //   eventLabel: this.eventInfo.eventID,
      //   eventCategory: this.eventInfo.eventID,
      //   eventAction: this.eventInfo.elementValue,
      //   eventValue: 1
      // })
      window.ga(this.eventInfo.eventMethod, this.eventInfo.eventID, this.eventInfo.elementValue || 1)
      window.ga('send', 'pageview')
    } catch (e) {
      console.error('error analytics', e)
    }
  }

  setTrackingAttributes() {
    this.components.forEach(nt => {
      this.viewTrackElement.push(nt)
    })
  }

  isComponentInPage(nt, index) {
    if (ValtTagManager.isElementInViewport(nt, 0.75)) {
      const name = `${nt.getAttribute('data-nt')}-${index}`
      if (!this.viewedComponents.includes(name)) {
        this.viewedComponents.push(name)
        this.sendEventInfo(nt, 'is-viewed', index)
      }
    }
  }

  static isElementInViewport(el, offsetTop) {
    const rect = el.getBoundingClientRect()
    return (
      rect.top >= 0 &&
      rect.top <=
        (window.innerHeight || document.documentElement.clientHeight) *
          offsetTop &&
      rect.left >= 0 &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }

  static throttle(callback, limit) {
    let wait = false
    return () => {
      if (!wait) {
        callback.call()
        wait = true

        setTimeout(() => {
          wait = false
        }, limit)
      }
    }
  }
}
export default window.digitalData
export const ValtechManager = new ValtTagManager()
